class PropertyDetailsHandlerClass extends elementorModules.frontend.handlers
	.Base {
	/**
	 * On Init
	 *
	 * Runs when the widget is loaded and initialized in the frontend.
	 */
	onInit() {
		//const widget = `div[data-id="${this.getID()}"] .xxx`;
		(function ($) {
			$(document).ready(function () {
				// widget code
				venoBox();
				//contactForm7PropertyAgent();
				contactForm7MessagePlaceholder();
				locationMap();
				contactForm7InsertLeadOnSubmit();
			});
		})(jQuery);
	}
}

function venoBox() {
	const venobox = new VenoBox({
		selector: "[data-lightbox]",
		numeration: true,
		infinigall: true,
		share: true,
		spinner: "grid",
	});
}

/* function contactForm7PropertyAgent() {
  const wpcf7FormElm = document.querySelector(
    ".property__contact-form .wpcf7.js"
  );
  const wpcf7AgentField = wpcf7FormElm.querySelector('[name=lead-agent]');
  const wpcf7MessageField = wpcf7FormElm.querySelector(
    "[name='your-message']"
  );
  const propertyAgentName = document.querySelector(
    ".property__agent-name"
  ).textContent;

  if (wpcf7FormElm && wpcf7MessageField && wpcf7AgentField && propertyAgentName) {
    wpcf7AgentField.value = propertyAgentName;

    const placeholderText = wpcf7MessageField.placeholder;
    wpcf7MessageField.placeholder = casafariData.wpml.agent + `: ${propertyAgentName} | ${placeholderText}`;
  }
} */

function contactForm7MessagePlaceholder() {
	const wpcf7FormElm = document.querySelector(
		".property__contact-form .wpcf7.js",
	);
	const wpcf7MessagePlaceholderText =
		wpcf7FormElm.querySelector("[name=message-placeholder]").value || "";
	console.log(wpcf7MessagePlaceholderText);
	const wpcf7MessageField = wpcf7FormElm.querySelector("[name='your-message']");

	wpcf7MessageField.placeholder = `${wpcf7MessagePlaceholderText}`;
}

function locationMap() {
	const mapEl = document.querySelector("#map.property__map");

	if (mapEl) {
		const latitude = mapEl.dataset.latitude;
		const longitude = mapEl.dataset.longitude;

		const map = L.map(mapEl, {
			center: [latitude, longitude],
			zoom: 16,
			maxZoom: 16,
		});

		L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
			maxZoom: 19,
			attribution:
				'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
		}).addTo(map);

		const circle = L.circle([latitude, longitude], {
			/* color: "#16273f",
    fillColor: "#fff", */
			color: "#16273f",
			fillColor: "#165a78",
			fillOpacity: 0.5,
			radius: 200,
		}).addTo(map);
	}
}

async function contactForm7InsertLeadOnSubmit() {
	const wpcf7FormElm = document.querySelector(
		".property__contact-form .wpcf7.js",
	);

	wpcf7FormElm.addEventListener(
		"wpcf7mailsent",
		async function (event) {
			const propertyId = wpcf7FormElm.querySelector("#property-id").value;
			const propertyReference = wpcf7FormElm.querySelector(
				"#property-reference",
			).value;
			const leadOriginId =
				wpcf7FormElm.querySelector("#lead-origin-id").value || 0;
			const leadAgent = wpcf7FormElm.querySelector("#lead-agent").value || "";
			const contactName = wpcf7FormElm.querySelector("#name").value || "";
			const contactEmail = wpcf7FormElm.querySelector("#email").value || "";
			const contactPhone = wpcf7FormElm.querySelector("#telephone").value || "";
			const contactMessage = wpcf7FormElm.querySelector("#message").value || "";

			const leadData = {
				action: "casafari_leads_insert",
				nonce: casafariData.ajaxNonce,
				leadTitle: `${contactName} - ${propertyReference} `,
				leadOriginId: leadOriginId,
				leadPropertyId: propertyId,
				leadName: contactName,
				leadEmail: contactEmail,
				leadPhone: contactPhone,
				leadMessage:
					casafariData.wpml.agent + `: ${leadAgent} | ${contactMessage} `,
				leadType: "Buyer",
			};

			// for debugging
			//console.log(leadData);
			console.log(await ajaxPost(casafariData.ajaxUrl, leadData));
		},
		false,
	);
}

async function ajaxPost(ajaxUrl, data) {
	const response = await fetch(ajaxUrl, {
		method: "POST",
		/* mode: "cors", */
		credentials: "same-origin",
		headers: new Headers({
			"Content-Type": "application/x-www-form-urlencoded",
			"X-WP-Nonce": casafariData.ajaxNonce,
		}),
		body: new URLSearchParams(data).toString(),
	});

	return response.json();
}

// init handler
/**
 * Registers the `widget - property - details` element handler.
 *
 * The handler is responsible for initializing the Swiper slider.
 *
 * @param {jQuery} $ - jQuery object.
 */
(function ($) {
	$(window).on("elementor/frontend/init", () => {
		elementorFrontend.elementsHandler.attachHandler(
			"widget-property-details",
			PropertyDetailsHandlerClass,
		);
	});
})(jQuery);
